import moment from 'moment-timezone';

const DEFAULT_FORMAT = 'll LTS';

function UnixTimeFilterer(format, {cellData}) {
  return cellData === undefined || cellData === null ? '' : moment.unix(cellData).format(format);
}

export default function(format) {
  if (typeof format === 'object') {
    return UnixTimeFilterer(DEFAULT_FORMAT, format);
  }
  return props => UnixTimeFilterer(format, props);
}
